import { z } from 'zod';
import { OrganizationSchema } from '../../../../entities/organization/organization.schema';
import { BaseErrorSchema } from '../../../../shared/error.schema';
/**
 * Show Tenant Organization Response Schema
 * GET /api/v2/tenants/:tenantId/organization
 */ export const ShowTenantOrganizationResponseSchema = z.object({
    data: OrganizationSchema
});
/**
 * Show Tenant Organization Error Schema
 */ export const ShowTenantOrganizationErrorSchema = BaseErrorSchema;

//# sourceMappingURL=show-tenant-organization.schema.js.map